module.exports = __webpack_public_path__ + "static/media/remember_11.ae371d0f.png";